import { Box } from "@material-ui/core";
import React from "react";
import Gift from '../../assets/gift.png'
import Gift1 from '../../assets/GIFT3.png'
import giftwrap from '../../assets/giftwrap.png'
import giftWork from '../../assets/giftworks.png'

const GiftCard=()=>{
    return(
    <div>

        <Box style={{background:"linear-gradient(5deg, rgb(255 255 255 / 0%) 0%, rgb(255 248 0 / 75%) 100%)"}}>
            <div style={{display:"flex",justifyContent:"center"}}>
            <img src={Gift}/>
   
            </div>
            <div style={{display:"flex", "justify-content":"center",position: "relative","bottom":"90px"}}>
            <div style={{width:"100%"}} >
            <div style={{display:"flex",justifyContent:"center"}}><div style={{width:"190px",height:"50px",background:"rgba(56, 79, 111, 1)",color:"white",borderRadius:"18px",    display:"flex",justifyContent:"center"}} >
                <h1 style={{fontSize:"14px",fontWeight:"500",padding:"5%",textAlign:"center"}}>Claim Gift Card Here</h1>
                </div>
                </div>
                <div style={{display:"flex",justifyContent:"center"}}>
                <div className="inputWithIcon" style={{position: "absolute",
    top: "26px", width:"90%"}}>
  <input className="hello"  type="text"  placeholder="Enter 6 Digit Gift Card Code" />
 
</div>
</div>
            </div>
      
            </div>
            
            <div style={{display:"flex",justifyContent:"center",    marginTop:"-37px"}}>
                <div style={{width:"90%"}}>
            <div style={{borderRadius:"18px","box-shadow": "0px 4px 35.4px 0px rgba(0, 0, 0, 0.1)",padding:"5%",background:"white"}}>
               <div style={{display:"flex",objectFit:"contain"}}>
               <div>
                 <h1 style={{fontWeight:"500",fontSize:"16px"}}>How it works?</h1>
               
                
                <p style={{fontWeight:"400",fontSize:"12px"}}>
                Claim your Daalchini gift card above and Buy your favorite snacks at any vending machine. 
                </p>
                </div>
                <img style={{width:"100px"}} src={giftWork}/>
                </div>
            </div>
            </div>
            </div>
            <div style={{display:"flex",justifyContent:"center", marginTop:"6%"  }}>
                <div style={{padding:"5%"}}>
            <div style={{borderTopLeftRadius:"18px",borderTopRightRadius:"18px","box-shadow": "0px 4px 35.4px 0px rgba(0, 0, 0, 0.1)",background:"white"}}>
            <h1 style={{fontSize:"16px",fontWeight:"500",padding:"5%"}} >Your Gift Cards (8)</h1>
            <div style={{  display: "flex","flex-wrap":"wrap","justify-content": "space-between"}}>
             
    {
        [1,2,2,3,4].map(()=>(
            <>
{false&&<div style={{width:"143px",height:"147px",border:"1px solid rgba(56, 79, 111, 0.44)",borderRadius:"41px",margin:"3%"}}>
    <img  style={{       "mix-blend-mode": "multiply",
    "border-top-right-radius": "33px",
    "border-top-left-radius":"33px"}} src={Gift1}/>
    <div style={{background: "rgba(250, 225, 75, 1)",         "border-top-left-radius": "7px","border-bottom-left-radius":"7px",   position: "absolute","margin-top":"-59px","margin-left": "85px"}}><h1 style={{color:"rgba(240, 129, 69, 1)",fontWeight:"500"}}>11d left</h1></div>

    <div style={{padding:"5%"}}>
        <h1 tyle={{fontWeight:"600",fontSize:"14px"}}>₹100.00</h1>
        <p style={{fontWeight:"400",fontSize:"8px"}}>Gift Card from a friend
Enjoy!</p>
        </div>
</div>}
{false&&<div style={{width:"143px",height:"147px",border:"1px solid rgba(56, 79, 111, 0.44)",borderRadius:"41px",margin:"3%"}}>
    <img  style={{       "mix-blend-mode": "multiply",
    "border-top-right-radius": "33px",
    "border-top-left-radius":"33px"}} src={giftwrap}/>


</div>}
{true&&<div style={{width:"143px",height:"147px",border:"1px solid rgba(56, 79, 111, 0.44)",borderRadius:"41px",margin:"3%"}}>
    <img  style={{       "mix-blend-mode": "multiply",
    "border-top-right-radius": "33px",
    "border-top-left-radius":"33px"}} src={Gift1}/>
    <div style={{background: "rgba(250, 225, 75, 1)",         "border-top-left-radius": "7px","border-bottom-left-radius":"7px",   position: "absolute","margin-top":"-24px",    width:"140px"}}><h1 style={{color:"rgba(240, 129, 69, 1)",fontWeight:"500",textAlign:"center"}}>Redeemed</h1></div>

    <div style={{padding:"5%"}}>
        <h1 tyle={{fontWeight:"600",fontSize:"14px"}}>₹100.00</h1>
        <p style={{fontWeight:"400",fontSize:"8px"}}>Gift Card from a friend
Enjoy!</p>
        </div>
</div>}
</>
        ))}


               </div>
            </div>
            </div>
            </div>
        </Box>
        
    </div>)
}
export default GiftCard;